module.exports = __webpack_public_path__ + "static/img/bg65.73314448.png";